<template>	   
	<v-container>
		<v-card>
			<v-layout row wrap>
			  <v-flex xs10 offset-xs1>
			    <v-text-field
			      name="name" v-model="dataForm.name"
			      label="Nombre"
			      id="id" solo
			    ></v-text-field>
			    <v-layout row wrap>
			      <v-flex xs6 pa-1>
				    <v-select
				      :items="frecuency" v-model="dataForm.frecuency"
				      label="Frecuencia" solo
				    ></v-select>
			      </v-flex>
			      <v-flex xs6 pa-1>
			      	<v-text-field
			      	  name="row_perquery"
			      	  label="Ejecucion por query"
			      	  id="row_perquery" solo
			      	  v-model="dataForm.row_perquery"
			      	></v-text-field>
			      </v-flex>	
			      <v-flex xs6 pa-1>
					    <v-select
					      :items="['Temporal', 'Permanente']"
					      label="Tipo" solo v-model="dataForm.type"
					    ></v-select>
			      </v-flex>
			      <v-flex xs6 pa-1> 
			        <v-checkbox label="Asignación de variables" v-model="dataForm.var_asignation"></v-checkbox>
			      </v-flex>

			      <v-flex xs6 pa-1>
			      	<v-text-field
			      	  name="init" solo
			      	  label="Fecha de inicio"
			      	  id="init" type="date" v-model="dataForm.init"
			      	></v-text-field>
			      </v-flex>
			      <v-flex xs6 pa-1>
			      	<v-text-field
			      	  name="end" solo
			      	  label="Fecha de finalización"
			      	  id="end" type="date" v-model="dataForm.end"
			      	></v-text-field>
			      </v-flex>
			    </v-layout>
			    <v-combobox solo
	            :items="selects.localities"
	            :item-text="item =>{return item.label + ' | ' + item.province}" 
	            item-value="value" 
							multiple
	            v-model="dataForm.localities"
	            label="Localidades"
	          >
						
          	<template v-slot:prepend-item>
				      <v-list-item
				        ripple
				        @click="toggleLocality"
				      >
				        <v-list-item-action>
				          <v-icon :color="dataForm.localities.length > 0 ? 'indigo darken-4' : ''">{{ iconLocalities }}</v-icon>
				        </v-list-item-action>
				        <v-list-item-content>
				          <v-list-item-title>Seleccionar todos</v-list-item-title>
				        </v-list-item-content>
				      </v-list-item>
				      <v-divider class="mt-2"></v-divider>
				    </template>
						<template v-slot:selection="{ item, index }">
						      <v-chip v-if="index < 6">
						        <span>{{ item.label }}</span>
						      </v-chip>
						      <span
						        v-if="index === 6"
						        class="grey--text caption"
						      >(+{{ dataForm.localities.length - 6 }} Otros)</span>
						</template>
				     
          </v-combobox>
			    <v-combobox solo
            :items="selects.variables"
            item-value="id" multiple
            :item-text="item =>{return item.name + ' | ' + item.category}"
            v-model="dataForm.layers"
            label="Variables"
          >
        	  <template v-slot:prepend-item>
				      <v-list-item
				        ripple
				        @click="toggleLayers"
				      >
				        <v-list-item-action>
				          <v-icon :color="dataForm.layers.length > 0 ? 'indigo darken-4' : ''">{{ iconLayers }}</v-icon>
				        </v-list-item-action>
				        <v-list-item-content>
				          <v-list-item-title>Seleccionar todos</v-list-item-title>
				        </v-list-item-content>
				      </v-list-item>
				      <v-divider class="mt-2"></v-divider>
				    </template>
						<template v-slot:selection="{ item, index }">
							<v-chip v-if="index < 6">
								<span>{{ item.name }} | {{ item.category }}</span>
							</v-chip>
							<span
								v-if="index === 6"
								class="grey--text caption"
							>(+{{ dataForm.layers.length - 6 }} Otros)</span>
						</template>
          </v-combobox>
			    <v-textarea
			      label="Descripción"
			      name="description"
			      textarea solo v-model="dataForm.description"
			    ></v-textarea>
			  </v-flex>
			</v-layout>
			<v-card-actions>
				<v-btn color="warning" @click="closeModal()">Cancelar</v-btn>
			  <v-btn color="success" @click="save()">Guardar</v-btn>
			</v-card-actions>
		</v-card>
		<v-snackbar :color="alert.color"
		  v-model="alert.active"
		>
		  {{alert.message}}
		  <v-btn text  @click.native="alert.active = false">Close</v-btn>
		</v-snackbar>
	</v-container>
</template>
<script>

	export default{
		components: {

		},
		created() {
			this.getSelect();
		},
		mounted(){

		},
		props: [
			'dataParent'
		],
		data(){
			return {
				baseRoute: process.env.VUE_APP_URL + 'api/gis/',
				frecuency: ['Diario', 'Semanal', 'Mensual', 'Anual'],
				selects: {
					localities: [],
					variables: [],
				},
				endMenu: false,
				initMenu: false,
				dataForm: {
					name: '',
					frecuency: '',
					type: '',
					init: '',
					end: '',
					var_asignation: false,
					row_perquery: '',
					localities: [],
					layers: [],
					description: '',
				},
				alert:{ 
					message: '',
					active: false,
					color: 'error'
				},
			}
		},
		methods: {
			toggleLocality () {
        this.$nextTick(() => {
          if (this.selectAllLocalities || this.selectSomeLocalities) {
            this.dataForm.localities = []
          } else {
            this.dataForm.localities = this.selects.localities
          }
        })
      },
      toggleLayers () {
        this.$nextTick(() => {
          if (this.selectAllLayers || this.selectSomeLayers) {
            this.dataForm.layers = []
          } else {
            this.dataForm.layers = this.selects.variables
          }
        })
      },
			getSelect(){
				this.getLocalities();
				this.getVariables();
			},
			getVariables(){
				axios.get(this.baseRoute + 'variables/getSelect').then((res) => {
					this.selects.variables = res.data;
				}).catch((error) => {
					this.alert = {
						message: 'Hay un error interno en el servidor pruebe nuevamente mas tarde',
						color: 'error',
						active: true,
						icon: 'fas fa-bell',						
					}
				});
			},
			getLocalities(){
				axios.get(this.baseRoute + 'district/getSelect/habilited').then((res) => {
					this.selects.localities = res.data;
				}).catch((error) => {

				});
			},
			save(){
				if(this.dataParent.edit){
					this.dataForm.localities = this.dataForm.localities.map(function(item){
						return item.value
					})
					this.dataForm.layers = this.dataForm.layers.map(function(item){
						return item.value
					})
					axios.put(this.baseRoute + 'dataProccess/update', this.dataForm).then((res) => {
						if(res.data == "Exito"){
							this.closeModal();	
						}else{
							this.alert = {
							'active': true,
							'message': "Hubo un problema con el servidor pruebe nuevamente",
							'color': "error"
						}
						}
					}).catch((error) => {
						this.alert = {
							'active': true,
							'message': "Hubo un problema con el servidor pruebe nuevamente",
							'color': "error"
						}
					})
				}else{
					this.dataForm.localities = this.dataForm.localities.map(function(item){
						return item.value
					})
					axios.post(this.baseRoute + 'dataProccess/store', this.dataForm).then((res) => {
						if(res.data == "Exito"){
							this.closeModal();
						}else{
							this.alert = {
								'active': true,
								'message': "Hubo un problema con el servidor pruebe nuevamente",
								'color': "error"
							}
						}
					}).catch((error) => {
						this.alert = {
							'active': true,
							'message': "Hubo un problema con el servidor pruebe nuevamente",
							'color': "error"
						}
					});					
				}
			},
			closeModal(){
				this.$emit('closemodal')
			},
			sanearList()
			{
				this.dataForm.localities = this.dataForm.localities.filter(item => {
					return typeof(item) != Object
				})
			}

		},
		watch: {
			dataParent: function() {
					if(this.dataParent.edit){
						this.dataForm = this.dataParent;
						
						let localities = this.selects.localities.filter(function(item){
							return this.dataForm.localities.includes(item.value)
						}.bind(this))
						this.dataForm.localities = localities
						let layers = this.selects.variables.filter(function(item){
							return this.dataForm.layers.includes(item.id)
						}.bind(this))
						this.dataForm.layers = layers
					}else{
						this.dataForm = {
							name: '',
							frecuency: '',
							type: '',
							localities: [],
							layers: [],
							description: '',
						}
						this.selects.localities =  this.selects.localities.map(function(item){
							item.active = false;
							return item
						})
						this.selects.variables = this.selects.variables.map(function(item){
		      		item.active = false;
		        	return item;
		        })
						//this.setIconsEdit();
					}
			}
		},
		computed: {
			selectAllLocalities () {
        return this.dataForm.localities.length === this.selects.localities.length
      },
      selectSomeLocalities () {
        return this.dataForm.localities.length > 0 && !this.selectAllLocalities
      },
			iconLocalities () {
        if (this.selectAllLocalities) return 'mdi-close-box'
        if (this.selectSomeLocalities) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
      selectAllLayers () {
        return this.dataForm.layers.length === this.selects.variables.length
      },
      selectSomeLayers () {
        return this.dataForm.layers.length > 0 && !this.selectAllLayers
      },
			iconLayers () {
        if (this.selectAllLayers) return 'mdi-close-box'
        if (this.selectSomeLayers) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
		},
	}
</script>